import type { TruckAd } from "@mobility-item-page/types";
import { KeyInfo } from "../../key-info/KeyInfo.tsx";
import { AxleType } from "../AxleType.tsx";
import { BootSize } from "../BootSize.tsx";
import { Box } from "../Box.tsx";
import { CabinType } from "../CabinType.tsx";
import { ChassisNumber } from "../ChassisNumber.tsx";
import { Engine } from "../Engine.tsx";
import { EuApproved } from "../EuApproved.tsx";
import { ExtraBrake } from "../ExtraBrake.tsx";
import { FirstRegistration } from "../FirstRegistration.tsx";
import { InteriorSize } from "../InteriorSize.tsx";
import { LengthCm } from "../LengthCm.tsx";
import { Make } from "../Make.tsx";
import { Mileage } from "../Mileage.tsx";
import { ModelYear } from "../ModelYear.tsx";
import { NoOfSeats } from "../NoOfSeats.tsx";
import { RegistrationNumber } from "../RegistrationNumber.tsx";
import { SpecificationsArea } from "../SpecificationsArea.tsx";
import { Suspension } from "../Suspension.tsx";
import { TailLift } from "../TailLift.tsx";
import { Transmission } from "../Transmission.tsx";
import { VehicleGroup } from "../VehicleGroup.tsx";
import { Payload, TotalWeight } from "../Weight.tsx";
import { Wheelbase } from "../Wheelbase.tsx";
import { NoOfPallets } from "./NoOfPallets.tsx";
import { TruckLocation } from "./TruckLocation.tsx";

export const TruckSpecifications = ({ ad }: { ad: TruckAd }) => {
  return (
    <SpecificationsArea>
      <KeyInfo>
        {/*General information*/}
        <Make make={ad.make} />
        <ModelYear year={ad.year} />
        <VehicleGroup segment={ad.segment} />

        {/*Product properties*/}
        <Engine engine={ad.engine} />
        <Mileage distance={ad.mileage} unit={ad.mileage_unit} />
        <Transmission transmission={ad.transmission} />
        <ExtraBrake extraBrake={ad.extra_brake} />
        <AxleType axleType={ad.axle_type} />
        <Wheelbase wheelbase={ad.wheelbase} />
        <Suspension suspension={ad.suspension} />
        <TailLift tailLift={ad.tail_lift} />
        <LengthCm lengthCm={ad.length} />
        {ad.weight?.total && <TotalWeight weight={ad.weight.total} />}
        {ad.weight?.cargo && <Payload weight={ad.weight.cargo} />}
        <CabinType cabinType={ad.cabin_type} />
        <Box box={ad.box} />
        <BootSize bootSize={ad.boot_size} />
        <InteriorSize interiorSize={ad.interior_size} />
        <NoOfPallets pallets={ad.pallets} />
        <NoOfSeats noOfSeats={ad.no_of_seats} />

        {/*Appearance*/}

        {/*Registration, warranty, owners, etc*/}
        <TruckLocation carLocation={ad.car_location} />
        <RegistrationNumber registrationNumber={ad.registration_number} />
        <ChassisNumber chassisNumber={ad.chassis_number} />
        <FirstRegistration firstRegistration={ad.first_registration} />
        <EuApproved euApproved={ad.eu_approved} euApprovedDate={ad.eu_approved_date} />
      </KeyInfo>
    </SpecificationsArea>
  );
};
